<div class="wrapper">
  <div class="title">{{'playlist.label.title' | translate }}</div>

  @if ((playlistsLoading$ | async)) {
    <tun-loader-v5 class="loader"></tun-loader-v5>
  }

  @if ((playlistsLoadingError$ | async)) {
    <div class="errorContainer">
      <p>{{'general.status.error.message' | translate}}</p>
      <button (click)="onRetry()" class="retryButton">
        <p>
          {{'general.status.error.retry' | translate }}
        </p>
      </button>
    </div>
  }

  <div >
  </div>

  @if (!(playlistsLoading$ | async) && !(playlistsLoadingError$ | async)) {
    <button
      class="create-button" (click)="onCreatePlaylist()"
      >
      <div class="create-icon-container">
        <tun-plus-icon-v5 class="icon icon-create-button"></tun-plus-icon-v5>
      </div>
      {{'playlist.button.newList' | translate}}
    </button>
  }

  @if (!(playlistsLoading$ | async) && !(playlistsLoadingError$ | async)) {
    <div class="scrollContainer">
      @if (favoriteList$ | async) {
        <tun-playlist-button-view
          class="playlist first"
          [playlist]="favoriteList$ | async"
          isFavorite="true"
          >
        </tun-playlist-button-view>
      }
      @for (playlist of (playlists$ | async); track playlist; let i = $index) {
        <tun-playlist-button-view
          class="playlist {{ (i == 0 && (favoriteList$ | async) == null) ? 'first' : ''}}"
          [playlist]="playlist"
          >
        </tun-playlist-button-view>
      }
      @if (!(hasCustomPlaylists$ | async)) {
        <div class="no-playlists">
          <p translate>playlist.status.none.info1</p>
          <p translate>playlist.status.none.info2</p>
          <!--<p>{{'playlist.info.noCustomPlaylists' | translate}}</p>-->
        </div>
      }
    </div>
  }
</div>
